export const strapi_api = 'https://api.review.lernbook.com';
